import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Container,
  StatusSection,
  StatusLabel,
  OrderItemsGrid,
  OrderItem,
  ItemField,
  FieldLabel,
  FieldValue,
} from './ExtendedOrderRow.styled';
import StatusSelect from '../StatusSelect/StatusSelect';
import formatCurrency from '../../../lib/formatCurrency';

const ExtendedOrderRow = ({orderId, status, onStatusChange, nestedRows}) => {
  const { t } = useTranslation();
  
  return (
    <Container>
      <StatusSection>
        <StatusLabel>{t('changeOrderStatus')}</StatusLabel>
        <StatusSelect
          orderId={orderId}
          onStatusChange={onStatusChange}
          status={status}
        />
      </StatusSection>
      
      <OrderItemsGrid>
        {nestedRows.map((row, index) => (
          <OrderItem key={row._id}>
            <ItemField>
              <FieldLabel>{t('seqNo')}</FieldLabel>
              <FieldValue>{index + 1}.</FieldValue>
            </ItemField>
            <ItemField>
              <FieldLabel>{t('orderName')}</FieldLabel>
              <FieldValue>{row.name}</FieldValue>
            </ItemField>
            <ItemField>
              <FieldLabel>{t('price')}</FieldLabel>
              <FieldValue>{formatCurrency(row.price)}</FieldValue>
            </ItemField>
            <ItemField>
              <FieldLabel>{t('quantity')}</FieldLabel>
              <FieldValue>{row.quantity}</FieldValue>
            </ItemField>
            <ItemField>
              <FieldLabel>{t('estimatedDeliveryDate')}</FieldLabel>
              <FieldValue>{row.deliveryDate}</FieldValue>
            </ItemField>
            <ItemField>
              <FieldLabel>{t('catalogNumber')}</FieldLabel>
              <FieldValue>{row.catalogNumber}</FieldValue>
            </ItemField>
            <ItemField>
              <FieldLabel>{t('ean')}</FieldLabel>
              <FieldValue>{row.ean}</FieldValue>
            </ItemField>
          </OrderItem>
        ))}
      </OrderItemsGrid>
    </Container>
  );
};

ExtendedOrderRow.propTypes = {
  orderId: PropTypes.string,
  nestedRows: PropTypes.array,
  onStatusChange: PropTypes.func,
};

export default ExtendedOrderRow;

// id: PropTypes.string,
// name: PropTypes.string,
// price: PropTypes.string,
// quantity: PropTypes.number,
// deliveryDate: PropTypes.string,
// catalogNumber: PropTypes.string,
// ean: PropTypes.string,
